import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from '../Message.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
};

export const MessageControls = ({ children, className }: Props) => {
  return (
    <div className={classNames(styles.MessageControls, className)}>
      {children}
    </div>
  );
};
